import React, { Component } from "react";
import { Row, Col, Table, Tag, Tooltip, Spin, Empty, Button } from "antd";
import { ReloadOutlined } from "@ant-design/icons";
import moment from "moment";
import { DynamicCardForm } from "../../../../Components/Items";
import { cmmsPost, formatoFecha, formatoMoneda, formatoPorcentaje, estatusEquipo } from "../cmmsComun";
import { Medidor, Tile } from "../componentes/IndicadoresCMMS";
import "../cmms.css";

// Progreso del contrato (lo que hoy sale del Dashboard de cada cliente y del "Reporte
// mensual" del C-SE-03): programado vs realizado en total, por vuelta, por mes, por
// sucursal y por ingeniero; atrasados, no realizados con su motivo y cobranza.

// Estatus del programa: colores de estado (reservados), siempre con etiqueta.
const SEGMENTOS = [
    { clave: "realizados", label: "Realizados", hex: "#2e9e6b" },
    { clave: "noRealizados", label: "No realizados", hex: "#d64545" },
    { clave: "atrasados", label: "Atrasados", hex: "#e8833a" },
    { clave: "resto", label: "Pendientes", hex: "#c9d2db" },
];

// Barra apilada de estatus: un segmento por estatus con 2px de separacion y tooltip.
const BarraEstatus = ({ r }) => {
    const valores = { realizados: r.realizados, noRealizados: r.noRealizados, atrasados: r.atrasados, resto: Math.max(r.pendientes - r.atrasados, 0) };
    if (!r.total) return <div className="cmms-barra-estatus vacia" />;
    return (
        <div className="cmms-barra-estatus">
            {SEGMENTOS.filter((s) => valores[s.clave] > 0).map((s) => (
                <Tooltip key={s.clave} title={`${s.label}: ${valores[s.clave]} de ${r.total} (${formatoPorcentaje(valores[s.clave] / r.total)})`}>
                    <span style={{ flexGrow: valores[s.clave], background: s.hex }} />
                </Tooltip>
            ))}
        </div>
    );
};

const Leyenda = () => (
    <div className="cmms-leyenda-estatus">
        {SEGMENTOS.map((s) => (
            <span key={s.clave}>
                <span className="cmms-cal-chip-punto" style={{ background: s.hex }} />
                {s.label}
            </span>
        ))}
    </div>
);

const columnasAvance = (titulo, dataIndex = "nombre") => [
    { title: titulo, dataIndex },
    { title: "Programados", dataIndex: "total", width: 105, align: "right" },
    { title: "Realizados", dataIndex: "realizados", width: 95, align: "right" },
    { title: "Atrasados", dataIndex: "atrasados", width: 90, align: "right", render: (v) => (v ? <b style={{ color: "#b4581c" }}>{v}</b> : 0) },
    { title: "No realizados", dataIndex: "noRealizados", width: 110, align: "right" },
    { title: "Avance", dataIndex: "avance", width: 190, render: (v) => <Medidor valor={v} /> },
];

class ProgresoContrato extends Component {
    state = { cargando: false, progreso: null };

    componentDidMount() {
        this.consultar();
    }

    componentDidUpdate(prev) {
        if (prev.recarga !== this.props.recarga) this.consultar();
    }

    consultar = async () => {
        this.setState({ cargando: true });
        try {
            const res = await cmmsPost(this.props, "progresoContratoCMMS", { contratoId: this.props.contrato._id });
            if (res.data.success === 2) this.setState({ progreso: res.data.progreso });
        } finally {
            this.setState({ cargando: false });
        }
    };

    render() {
        const p = this.state.progreso;
        if (!p) return <Spin spinning={this.state.cargando}><div style={{ minHeight: 200 }} /></Spin>;
        const r = p.resumen;
        const c = p.contrato;
        const verActivo = (id) => this.props.history.push("/panel/cmmsFichaActivo", { id });
        return (
            <Spin spinning={this.state.cargando}>
                <Row gutter={14}>
                    <Col xs={24}>
                        <div className="cmms-tiles">
                            <Tile titulo="Avance del contrato" valor={formatoPorcentaje(r.avance)} detalle={`${r.realizados} de ${r.total} servicios del programa`}>
                                <Medidor valor={r.avance} texto="" />
                            </Tile>
                            <Tile titulo="Pendientes" valor={r.pendientes} detalle={`${r.sinFecha} sin fecha · ${r.calendarizados} calendarizados · ${r.enProceso} en proceso`} />
                            <Tile titulo="Atrasados" valor={<span style={{ color: r.atrasados ? "#b4581c" : undefined }}>{r.atrasados}</span>} detalle="Su fecha ya pasó sin servicio" />
                            <Tile titulo="No realizados" valor={r.noRealizados} detalle="Con motivo (ver abajo)" />
                            <Tile
                                titulo="Vigencia"
                                valor={c.diasRestantes !== null && c.diasRestantes >= 0 ? `${c.diasRestantes} días` : c.estatusNombre}
                                detalle={`${formatoFecha(c.fechaInicio)} – ${formatoFecha(c.fechaConclusion)}`}
                            >
                                <Tag color={c.estatusColor}>{c.estatusNombre}</Tag>
                            </Tile>
                            <Tile titulo="Cobrado" valor={formatoMoneda(p.cobranza.cobrado) || "$0.00"} detalle={c.valorVariable ? "Valor variable" : c.valor ? `de ${formatoMoneda(c.valor)} del contrato` : "Sin valor capturado"}>
                                {c.valor && !c.valorVariable ? <Medidor valor={p.cobranza.porcentajeCobrado} /> : null}
                            </Tile>
                        </div>
                    </Col>

                    <DynamicCardForm
                        title="Por vuelta"
                        xs={24}
                        headerRight={
                            <Button size="small" icon={<ReloadOutlined />} onClick={this.consultar}>
                                Actualizar
                            </Button>
                        }
                    >
                        {!p.porVuelta.length ? (
                            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="El contrato no tiene vueltas" />
                        ) : (
                            <>
                                {p.porVuelta.map((v) => (
                                    <div key={v._id} className="cmms-progreso-vuelta">
                                        <div className="cmms-progreso-vuelta-cab">
                                            <b>{v.nombre}</b>
                                            <span style={{ color: "#5b6b7c" }}>
                                                {formatoFecha(v.fechaInicio)} – {formatoFecha(v.fechaFin)}
                                            </span>
                                            {v.vigente ? <Tag color="blue">En curso</Tag> : null}
                                            <span style={{ marginLeft: "auto", color: "#1f2a37" }}>
                                                <b>{formatoPorcentaje(v.avance)}</b> · {v.realizados} de {v.total}
                                                {v.atrasados ? ` · ${v.atrasados} atrasados` : ""}
                                                {v.sinFecha ? ` · ${v.sinFecha} sin fecha` : ""}
                                            </span>
                                        </div>
                                        <BarraEstatus r={v} />
                                    </div>
                                ))}
                                <Leyenda />
                            </>
                        )}
                    </DynamicCardForm>

                    <DynamicCardForm title="Por mes" xs={24} lg={12}>
                        <div className="cmms-ayuda">Programados según su fecha calendarizada; realizados según la fecha en que se concluyó el servicio.</div>
                        <Table
                            size="small"
                            rowKey="mes"
                            pagination={false}
                            dataSource={p.porMes}
                            locale={{ emptyText: "Todavía no hay fechas" }}
                            columns={[
                                { title: "Mes", dataIndex: "mes", render: (v) => moment(v, "YYYY-MM").format("MMMM YYYY") },
                                { title: "Programados", dataIndex: "programados", width: 105, align: "right" },
                                { title: "Realizados", dataIndex: "realizados", width: 95, align: "right" },
                                { title: "Cumplimiento", width: 170, render: (m) => (m.programados ? <Medidor valor={m.realizados / m.programados} /> : "—") },
                            ]}
                        />
                    </DynamicCardForm>
                    <DynamicCardForm title="Por ingeniero" xs={24} lg={12}>
                        <Table size="small" rowKey="clave" pagination={false} dataSource={p.porIngeniero} columns={columnasAvance("Ingeniero")} scroll={{ x: 650 }} />
                    </DynamicCardForm>
                    <DynamicCardForm title="Por sucursal / unidad" xs={24}>
                        <Table size="small" rowKey="clave" pagination={{ pageSize: 15, size: "small", hideOnSinglePage: true }} dataSource={p.porSucursal} columns={columnasAvance("Sucursal")} scroll={{ x: 650 }} />
                    </DynamicCardForm>

                    <DynamicCardForm title={`Atrasados (${r.atrasados})`} xs={24} lg={12}>
                        <Table
                            size="small"
                            rowKey="_id"
                            pagination={{ pageSize: 10, size: "small", hideOnSinglePage: true }}
                            dataSource={p.atrasados}
                            locale={{ emptyText: "Nada atrasado" }}
                            columns={[
                                { title: "Fecha", dataIndex: "fechaPlaneada", width: 110, render: (v) => formatoFecha(v) },
                                {
                                    title: "Equipo",
                                    dataIndex: "activoTexto",
                                    render: (v, x) => (
                                        <Button type="link" size="small" style={{ padding: 0, height: "auto", whiteSpace: "normal", textAlign: "left" }} onClick={() => verActivo(x.activoId)}>
                                            {v}
                                        </Button>
                                    ),
                                },
                                { title: "Vuelta", dataIndex: "vueltaNombre", width: 100 },
                                { title: "Ingeniero", dataIndex: "empleadoNombre", width: 150 },
                            ]}
                        />
                    </DynamicCardForm>
                    <DynamicCardForm title={`No realizados (${r.noRealizados})`} xs={24} lg={12}>
                        {p.motivos.length > 0 && (
                            <div className="cmms-motivos">
                                {p.motivos
                                    .sort((a, b) => b.n - a.n)
                                    .map((m) => (
                                        <Tag key={m.motivo}>
                                            {m.motivo}: <b>{m.n}</b>
                                        </Tag>
                                    ))}
                            </div>
                        )}
                        <Table
                            size="small"
                            rowKey="_id"
                            pagination={{ pageSize: 10, size: "small", hideOnSinglePage: true }}
                            dataSource={p.noRealizados}
                            locale={{ emptyText: "Ninguno" }}
                            columns={[
                                {
                                    title: "Equipo",
                                    dataIndex: "activoTexto",
                                    render: (v, x) => (
                                        <Button type="link" size="small" style={{ padding: 0, height: "auto", whiteSpace: "normal", textAlign: "left" }} onClick={() => verActivo(x.activoId)}>
                                            {v}
                                        </Button>
                                    ),
                                },
                                { title: "Vuelta", dataIndex: "vueltaNombre", width: 100 },
                                { title: "Motivo", dataIndex: "motivo", width: 220 },
                            ]}
                        />
                    </DynamicCardForm>

                    <DynamicCardForm title="Equipos por estatus" xs={24} lg={12}>
                        <Table
                            size="small"
                            rowKey="estatus"
                            pagination={false}
                            dataSource={p.equiposPorEstatus}
                            locale={{ emptyText: "Sin equipos" }}
                            columns={[
                                { title: "Estatus", dataIndex: "estatus", render: (v, x) => <Tag color={estatusEquipo(v).color}>{x.nombre}</Tag> },
                                { title: "Equipos", dataIndex: "n", width: 100, align: "right" },
                            ]}
                        />
                    </DynamicCardForm>
                    <DynamicCardForm title="Servicios concluidos del contrato" xs={24} lg={12}>
                        <div className="cmms-ayuda">Todos los servicios del contrato, incluidos correctivos y diagnósticos que no están en el programa.</div>
                        <Table
                            size="small"
                            rowKey="tipoServicio"
                            pagination={false}
                            dataSource={p.serviciosPorTipo}
                            locale={{ emptyText: "Ninguno todavía" }}
                            columns={[
                                { title: "Tipo de servicio", dataIndex: "nombre" },
                                { title: "Servicios", dataIndex: "n", width: 90, align: "right" },
                                { title: "Monto", dataIndex: "monto", width: 130, align: "right", render: (v) => (v ? formatoMoneda(v) : "—") },
                            ]}
                        />
                    </DynamicCardForm>
                </Row>
            </Spin>
        );
    }
}

export default ProgresoContrato;
